export default __webpack_public_path__ + "static/bt-screen-android-mobile@2x-215834165cfb19327a41b4566a76d96d.webp";